import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import {
  GetDataItemDeactive,
  toggleComment,
  toggleCommentReplies,
} from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { DataSearch } from "./Components/Services";
import CustomModal from "../../../Common/Components/Modal/CustomModal";

import { Set } from "../../../../Request";

function ItemsComments() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
  };
  const [filter, setfilter] = useState({ rel_type: "item" });
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    ItemHandler();
  }, []);
  const ItemHandler = (pageNumber = 1, data, limit, index, filter) => {
    setstate({ ...state, loading: true });
    GetDataItemDeactive(pageNumber, data, limit, index, filter).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const SearchComment = data => {
    setstate({ ...state, loading: true });
    DataSearch({ name: data }).then(data => {
      setstate({ loading: false, data: data });
    });
  };

  const changeStatus = id => {
    toggleComment({
      comment_id: id,
    }).then(() => {
      ItemHandler();
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست کامنت ها</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "نام و نام خانوادگی نظر دهنده",
            keyName: "fullname",
            key: "comenter",
          },
          {
            title: "نظر برای",
            key: "commented",
            type: "state",
            method: row => {
              if (row) {
                if (row.rel_type == "Blog") {
                  return row.commented.title.toString().length > 25
                    ? row.commented.title.toString().substr(0, 25) + "..."
                    : row.commented.title;
                }
                if (row.rel_type == "Item") {
                  return row.commented.name;
                }
                if (row.rel_type == "SportClass") {
                  return row.commented.name;
                }
              } else {
                return "ثبت نشده";
              }
            },
          },
          {
            title: "مربوط به",
            key: "rel_type",
            type: "enum",
            enum: {
              Item: "مجموعه",
              Blog: "مقالات",
              SportClass: "کلاس",
            },
          },
          {
            title: "متن  کامنت",
            key: "text",
            type: "long",
          },
          {
            title: "تعداد پاسخ",
            key: "replies_all_count",
          },
          {
            title: "وضعیت",
            key: "status",
            type: "enum",
            enum: {
              off: "در حال انتظار تایید",
              on: "تایید شده",
            },
          },
        ]}
        textEmpty="کامنتی ثبت نشده"
        list={state.data && state.data.data}
        data={state.data}
        search={SearchComment}
        function={ItemHandler}
        currentPage={state.data && state.data.current_page}
        header="لیست کامنت های غیرفعال"
        links={[
          {
            typeLink: "sort",
            html: (
              <Fragment>
                <select
                  className="form-control"
                  onChange={e => {
                    setfilter({ ...filter, status: e.target.value });
                    // ItemHandler(null, null, null, filter);
                  }}
                >
                  <option value={""}> وضعیت </option>
                  <option value={""}> مشاهده همه </option>
                  <option value={"on"}> فعال </option>
                  <option value={"off"}> غیر فعال</option>

                  {/* replies */}
                </select>
              </Fragment>
            ),
          },

          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            size: "col-md-2",
            html: "مشاهده",
            main: true,
            type: "show",
          },
          {
            function: selected => {
              changeStatus(selected[0]);
            },
            color: "danger",
            size: "col-md-2",
            html: "تغییر وضعیت",
            multi: false,
            type: "toggle",
          },
        ]}
      />

      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
          ItemHandler();
        }}
        header={"مشاهده کامنت"}
      >
        <CommentInfo
          value={
            state.data.data &&
            state.data.data.filter(item => item.id === state.modal)[0]
          }
          setstate={setstate}
          state={state}
          ItemHandler={ItemHandler}
        />
      </CustomModal>
    </Fragment>
  );
}
const CommentInfo = ({ ItemHandler, value, setstate, state }) => {
  const { form, setForm, sendData, loading, changeStatus, loadingBtn } =
    useComment();

  const renderData = data => {
    switch (data.rel_type) {
      case "admin":
        return {
          text: "پشتیبان",
          right: true,
          status: false,
          label: null,
        };
        break;
      case "manager":
        if (data.status == "on") {
          return {
            text: "مدیر مجموعه",
            right: false,
            status: "active",
            label: <span className="badge bg-success"> فعال</span>,
          };
        } else {
          return {
            text: "مدیر مجموعه",
            right: false,
            status: "deactive",
            label: <span className="badge bg-danger"> غیر فعال</span>,
          };
        }

      case "user":
        if (data.status == "on") {
          return {
            text: value.comenter.fullname,
            right: false,
            status: "active",
            label: <span className="badge bg-success"> فعال</span>,
          };
        } else {
          return {
            text: value.comenter.fullname,
            right: false,
            status: "deactive",
            label: <span className="badge bg-danger"> غیر فعال</span>,
          };
        }

      default:
        break;
    }
  };
  return (
    <div>
      <div>
        <h6>{value && value.comenter && value.comenter.fullname}</h6>
      </div>
      <div>
        <p style={{ fontSize: "12px" }}>{value && value.text}</p>
      </div>
      {value &&
        value.replies_all &&
        value.replies_all.map((message, key) => {
          return (
            <div className="border p-2 mb-2" key={key}>
              {renderData(message)["label"]}
              <h6>{renderData(message)["text"]}</h6>

              <p style={{ fontSize: "10px" }}>{message.message}</p>
              {renderData(message)["status"] && (
                <button
                  disabled={loadingBtn}
                  onClick={() => {
                    changeStatus({ comment_id: message.id });
                    setstate({ ...state, modal: false });
                    ItemHandler();
                  }}
                  className="btn btn-primary"
                >
                  {loadingBtn ? "در حال ارسال" : "تغییر وضعیت"}
                </button>
              )}
            </div>
          );
        })}
      <div className="d-flex flex-column">
        <label htmlFor="">پاسخ شما</label>
        <textarea
          onChange={({ target: { value } }) => {
            setForm({ ...form, message: value });
          }}
          name=""
          id=""
          cols="30"
          rows="5"
          placeholder="پاسخ ..."
        ></textarea>
      </div>
      <div className="d-flex justify-content-center">
        <button
          onClick={() => {
            sendData({ commnet_id: value.id });
            setstate({ ...state, modal: false });
            ItemHandler();
          }}
          disabled={loading}
          className="btn btn-primary mt-2"
        >
          {loading ? "در حال ارسال " : "ارسال"}
        </button>
      </div>
    </div>
  );
};
export default ItemsComments;

const useComment = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const sendData = async data => {
    setLoading(true);
    await Set({
      url: "/comment/admin_answer",
      data: { ...form, ...data },
    }).then(() => {
      setLoading(false);
    });
  };
  const changeStatus = async data => {
    setLoadingBtn(true);
    await Set({
      url: "/commentreplies/change_status",
      data: { ...form, ...data },
    }).then(() => {
      setLoadingBtn(false);
    });
  };
  return {
    form,
    setForm,
    sendData,
    loading,
    changeStatus,
    loadingBtn,
  };
};
